import React from 'react';
import { Check, KeyRound, Building2, Package, ClipboardList } from 'lucide-react';

const STEPS = [
  {
    number: 1,
    icon: KeyRound,
    name: 'Welcome & Password',
    description: 'Secure your account',
  },
  {
    number: 2,
    icon: Building2,
    name: 'Company Profile',
    description: 'Set up your business identity',
  },
  {
    number: 3,
    icon: Package,
    name: 'First Product',
    description: 'Add to the AR catalog',
  },
  {
    number: 4,
    icon: ClipboardList,
    name: 'Account Checklist',
    description: 'Complete your setup',
  },
];

export default function WizardProgressSidebar({ currentStep, completedSteps }) {
  return (
    <div
      className="w-72 flex-shrink-0 flex flex-col"
      style={{
        background: 'rgba(255,255,255,0.02)',
        borderLeft: '1px solid rgba(0,229,255,0.1)',
        padding: '40px 28px',
      }}
    >
      <div className="mb-8">
        <p className="text-xs font-semibold uppercase tracking-widest mb-1" style={{ color: '#00E5FF', fontFamily: 'DM Sans, sans-serif' }}>Setup Progress</p>
        <p className="text-sm" style={{ color: '#475569', fontFamily: 'DM Sans, sans-serif' }}>Step {currentStep} of 4</p>
        {/* Progress bar */}
        <div className="mt-3 h-1.5 rounded-full overflow-hidden" style={{ background: 'rgba(255,255,255,0.06)' }}>
          <div
            className="h-full rounded-full transition-all duration-700"
            style={{
              width: `${(currentStep / 4) * 100}%`,
              background: 'linear-gradient(90deg, #00E5FF, #7B2FBE)',
            }}
          />
        </div>
      </div>
      <div className="flex flex-col gap-2">
        {STEPS?.map((step) => {
          const isCompleted = completedSteps?.includes(step?.number);
          const isActive = currentStep === step?.number;
          const isUpcoming = !isCompleted && !isActive;
          const StepIcon = step?.icon;

          return (
            <div
              key={step?.number}
              className="flex items-start gap-3 p-3 rounded-xl transition-all duration-300"
              style={{
                background: isActive ? 'rgba(0,229,255,0.06)' : 'transparent',
                border: isActive ? '1px solid rgba(0,229,255,0.15)' : '1px solid transparent',
              }}
            >
              {/* Step circle */}
              <div className="relative flex-shrink-0 mt-0.5">
                <div
                  className="w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300"
                  style={{
                    background: isCompleted
                      ? 'rgba(0,229,255,0.2)'
                      : isActive
                      ? 'linear-gradient(135deg, rgba(0,229,255,0.25), rgba(123,47,190,0.25))'
                      : 'rgba(255,255,255,0.04)',
                    border: isCompleted
                      ? '2px solid #00E5FF'
                      : isActive
                      ? '2px solid #00E5FF' :'2px solid rgba(255,255,255,0.1)',
                    boxShadow: isActive ? '0 0 12px rgba(0,229,255,0.3)' : 'none',
                  }}
                >
                  {isCompleted ? (
                    <Check size={14} style={{ color: '#00E5FF' }} />
                  ) : isActive ? (
                    <StepIcon size={14} style={{ color: '#00E5FF' }} />
                  ) : (
                    <span className="text-xs font-bold" style={{ color: '#475569', fontFamily: 'DM Sans, sans-serif' }}>{step?.number}</span>
                  )}
                </div>
                {/* Pulsing ring for active */}
                {isActive && (
                  <div
                    className="absolute inset-0 rounded-full animate-ping"
                    style={{ background: 'rgba(0,229,255,0.15)', animationDuration: '2s' }}
                  />
                )}
              </div>
              {/* Step info */}
              <div className="flex-1 min-w-0">
                <p
                  className="text-sm font-semibold leading-tight"
                  style={{
                    color: isCompleted ? '#00E5FF' : isActive ? '#E2E8F0' : '#475569',
                    fontFamily: 'DM Sans, sans-serif',
                  }}
                >
                  {step?.name}
                </p>
                <p
                  className="text-xs mt-0.5"
                  style={{ color: isActive ? '#64748B' : '#334155', fontFamily: 'DM Sans, sans-serif' }}
                >
                  {step?.description}
                </p>
                {isCompleted && (
                  <span
                    className="inline-block text-xs font-medium mt-1 px-2 py-0.5 rounded-full"
                    style={{ background: 'rgba(0,229,255,0.1)', color: '#00E5FF', fontFamily: 'DM Sans, sans-serif' }}
                  >
                    Complete
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
      {/* Help section */}
      <div className="mt-auto pt-8">
        <div
          className="p-4 rounded-xl"
          style={{ background: 'rgba(123,47,190,0.08)', border: '1px solid rgba(123,47,190,0.2)' }}
        >
          <p className="text-xs font-semibold mb-1" style={{ color: '#7B2FBE', fontFamily: 'DM Sans, sans-serif' }}>Need help?</p>
          <p className="text-xs" style={{ color: '#475569', fontFamily: 'DM Sans, sans-serif' }}>Contact us at</p>
          <p className="text-xs font-medium" style={{ color: '#94A3B8', fontFamily: 'DM Sans, sans-serif' }}>support@finvisar.com</p>
        </div>
      </div>
    </div>
  );
}
